import Image from 'next/legacy/image';

import { BodyRegular } from '@common/body';
import { H3 } from '@common/headline';
import { TakeOurQuizButton } from '../Hero/TakeOurQuizCTA';

import ComparisonTable from '@public/img/home-page/mounjaro-comparison-table.png';
import ComparisonTableMobile from '@public/img/home-page/mounjaro-comparison-table-mobile.png';

type Props = {
  utmCampaign?: string;
  utmMedium?: string;
  utmSource?: string;
};

export const MounjaroComparisonSection = ({
  utmCampaign,
  utmMedium,
  utmSource,
}: Props): JSX.Element => (
  <div className="flex h-[1150px] justify-center bg-salmon md:h-[621px] md:px-[60px]">
    <div className="flex flex-col md:w-[1246px] md:flex-row md:justify-between">
      <div className="mx-auto mt-16 flex max-w-[580px] md:mt-0 md:w-[426px] md:flex-auto md:basis-2/5">
        <div className="flex flex-col justify-center text-blue xl:max-w-[426px]">
          <div className="px-3 text-center md:px-0 md:text-left">
            <H3>More than just a drug</H3>
            <div className="mt-6">
              <BodyRegular>
                With the power of psychology and habit formation, we{"'"}ll
                teach you how to retrain your mind to make healthy habits second
                nature.
              </BodyRegular>
            </div>
          </div>
          <div className="hidden md:static md:mb-6 md:mt-[32px] md:flex md:justify-start">
            <TakeOurQuizButton
              colour="NavyBlue"
              ctaText="Check my eligibility"
              isGlp1
              location="Mounjaro comparison section"
              type="Primary"
              utmCampaign={utmCampaign}
              utmMedium={utmMedium}
              utmSource={utmSource}
            />
          </div>
        </div>
      </div>
      <div className="mt-[60px] hidden flex-auto justify-end md:flex md:w-[50%] md:basis-3/5">
        <div className="flex w-[100%]">
          <div className="relative w-[100%] lg:mb-20">
            <Image
              alt={'Comparison table'}
              layout="fill"
              objectFit="contain"
              placeholder="blur"
              src={ComparisonTable}
            />
          </div>
        </div>
      </div>
      <div className="mt-10 flex justify-end md:hidden">
        <div className="flex w-[100%] justify-center">
          <Image
            alt={'Comparison table'}
            height={752}
            objectFit="contain"
            placeholder="blur"
            src={ComparisonTableMobile}
            width={343}
          />
        </div>
      </div>
      <div className="mt-12 flex h-6 w-full justify-center px-3 md:hidden">
        <div className="w-full max-w-[351px]">
          <TakeOurQuizButton
            colour="NavyBlue"
            ctaText="Check my eligibility"
            fullWidth
            isGlp1
            location="Mounjaro comparison section"
            type="Primary"
            utmCampaign={utmCampaign}
            utmMedium={utmMedium}
            utmSource={utmSource}
          />
        </div>
      </div>
    </div>
  </div>
);
